"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactResponsiveModal = _interopRequireDefault(require("react-responsive-modal"));
var _Button = _interopRequireDefault(require("../Button"));
var _localization = require("@lt/localization");
require("react-responsive-modal/styles.css");
var _excluded = ["children", "label", "showCloseButton", "closeButtonText", "options", "onClosePopup", "withPadding", "isFullscreen", "className", "isInitialOpen", "onClear", "zIndex", "bgColor"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = function styles(zIndex) {
  return {
    overlay: {
      zIndex: zIndex || 10001,
      background: 'rgba(145,148,153,.5)'
    },
    modal: {
      padding: 0,
      background: 'none'
    },
    closeButton: {
      zIndex: 9,
      top: 6,
      right: 10
    }
  };
};
var defaultPadding = 10;
var buttonHeight = 50;

// react-responsive-modal props
var DEFAULT_OPTIONS = {
  showCloseIcon: true,
  center: true,
  focusTrapped: false
};
var MobilePopup = function MobilePopup(_ref) {
  var children = _ref.children,
    label = _ref.label,
    showCloseButton = _ref.showCloseButton,
    closeButtonText = _ref.closeButtonText,
    options = _ref.options,
    onClosePopup = _ref.onClosePopup,
    withPadding = _ref.withPadding,
    isFullscreen = _ref.isFullscreen,
    className = _ref.className,
    _ref$isInitialOpen = _ref.isInitialOpen,
    isInitialOpen = _ref$isInitialOpen === void 0 ? false : _ref$isInitialOpen,
    onClear = _ref.onClear,
    zIndex = _ref.zIndex,
    bgColor = _ref.bgColor,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(isInitialOpen),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isOpen = _useState2[0],
    setOpen = _useState2[1];
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  (0, _react.useEffect)(function () {
    setOpen(isInitialOpen);
  }, [isInitialOpen]);
  var onClose = function onClose() {
    setOpen(false);
    onClosePopup();
  };
  var handleClear = function handleClear() {
    onClear();
    setOpen(false);
  };
  var onOpen = function onOpen() {
    return setOpen(true);
  };
  var modalParams = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
  return /*#__PURE__*/_react["default"].createElement("div", rest, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    functional: true,
    onClick: onOpen,
    bgColor: bgColor
  }, label), /*#__PURE__*/_react["default"].createElement(_reactResponsiveModal["default"], (0, _extends2["default"])({
    open: isOpen,
    styles: styles(zIndex),
    onClose: onClose
  }, modalParams), /*#__PURE__*/_react["default"].createElement(StyledContainer, {
    className: className,
    $isFullscreen: isFullscreen,
    $withPadding: withPadding
  }, onClear && /*#__PURE__*/_react["default"].createElement(StyledCancelButtonWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledCancelButton, {
    functional: true,
    onClick: handleClear
  }, /*#__PURE__*/_react["default"].createElement("span", null, t('filters.panel.cancel')))), /*#__PURE__*/_react["default"].createElement(StyledContent, {
    $isFullscreen: isFullscreen,
    $withButton: showCloseButton
  }, children), showCloseButton && /*#__PURE__*/_react["default"].createElement(StyledCloseButtonWrapper, {
    withMargin: !withPadding
  }, /*#__PURE__*/_react["default"].createElement(StyledCloseButton, {
    primary: true,
    onClick: onClose
  }, closeButtonText)))));
};
MobilePopup.propTypes = {
  className: _propTypes["default"].string,
  closeButtonText: _propTypes["default"].string,
  label: _propTypes["default"].node.isRequired,
  children: _propTypes["default"].node.isRequired,
  showCloseButton: _propTypes["default"].bool,
  showCancelButton: _propTypes["default"].bool,
  // react-responsive-modal props
  options: _propTypes["default"].shape({}),
  onClosePopup: _propTypes["default"].func,
  withPadding: _propTypes["default"].bool
};
MobilePopup.defaultProps = {
  className: '',
  closeButtonText: 'Закрыть',
  showCloseButton: false,
  showCancelButton: false,
  options: {},
  onClosePopup: Function.prototype,
  withPadding: true
};
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "MobilePopup__StyledContainer",
  componentId: "sc-5ofcd7-0"
})(["position:relative;background:var(--white);max-width:95vw;min-width:250px;max-height:90vh;box-shadow:var(--box-shadow);border-radius:var(--border-radius);padding:", ";overflow:hidden;", ""], function (_ref2) {
  var $withPadding = _ref2.$withPadding;
  return $withPadding && "".concat(defaultPadding, "px");
}, function (_ref3) {
  var $isFullscreen = _ref3.$isFullscreen;
  return $isFullscreen && (0, _styledComponents.css)(["max-width:unset;max-height:unset;width:100vw;height:100vh;box-shadow:unset;border-radius:unset;"]);
});
var StyledContent = _styledComponents["default"].div.withConfig({
  displayName: "MobilePopup__StyledContent",
  componentId: "sc-5ofcd7-1"
})(["", " overflow:auto;"], function (_ref4) {
  var $isFullscreen = _ref4.$isFullscreen,
    $withButton = _ref4.$withButton;
  return $isFullscreen && "height: ".concat($withButton ? 'calc(100dvh - 112px)' : '100dvh');
});
var StyledCloseButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "MobilePopup__StyledCloseButton",
  componentId: "sc-5ofcd7-2"
})(["width:100%;height:", "px;font-size:16px;font-style:normal;font-weight:500;line-height:20px;"], buttonHeight);
var StyledCloseButtonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "MobilePopup__StyledCloseButtonWrapper",
  componentId: "sc-5ofcd7-3"
})(["", ""], function (_ref5) {
  var withMargin = _ref5.withMargin;
  return withMargin && (0, _styledComponents.css)(["margin:0 ", "px ", "px;"], defaultPadding, defaultPadding);
});
var StyledCancelButtonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "MobilePopup__StyledCancelButtonWrapper",
  componentId: "sc-5ofcd7-4"
})(["width:100%;display:flex;flex-direction:row-reverse;"]);
var StyledCancelButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "MobilePopup__StyledCancelButton",
  componentId: "sc-5ofcd7-5"
})(["color:var(--secondary);font-size:16px;font-style:normal;font-weight:400;line-height:20px;padding:16px 8px;"]);
MobilePopup.StyledContainer = StyledContainer;
var _default = exports["default"] = MobilePopup;